// extracted by css-extract-rspack-plugin
export default {"chart":"chart--sXqZUhJQJ_ULVBEG","chartEmpty":"chart-empty--of9V7MaIzceaIcNt"};